import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { isEmpty } from 'lodash';
let LevelTable = class LevelTable extends Vue {
    get headers() {
        const firstLevel = Math.min(...(Object.keys(this.levels).map((level) => parseInt(level))));
        return Object.keys(this.levels[firstLevel.toString()]);
    }
    get hasLevels() {
        return !isEmpty(this.levels);
    }
};
__decorate([
    Prop(String)
], LevelTable.prototype, "title", void 0);
__decorate([
    Prop(Object)
], LevelTable.prototype, "levels", void 0);
LevelTable = __decorate([
    Component
], LevelTable);
export default LevelTable;
